import { z } from 'zod';

import { name, phone, privacy_consent } from '@/utils/validationSchemes';

export const callbackFormSchema = z
  .object({ name, phone, privacy_consent })

export type CallbackFormSchema = z.infer<typeof callbackFormSchema>;